ObjectUtils.define('UIRadioSelectorController', UIController, {

  didControlChangeValue: function didControlChangeValue(container, control, data) {
    // Can be unselected initially
    var currentSelectedRadioContainer = DOM.maybeFindBySelector(container, '.labelledRadioContainer.selected');
    if (currentSelectedRadioContainer) {
      DOM.removeClass(currentSelectedRadioContainer, 'selected');
    }

    var labelledRadioContainer = DOM.findParentByClass(control, 'labelledRadioContainer');
    DOM.addClass(labelledRadioContainer, 'selected');
  },
});
